import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import { AiOutlineDownload, AiOutlineFolderView } from "react-icons/ai";

function Resume() {
  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            style={{ width: "fit-content" }}
            variant="primary"
            rel="noreferrer"
            href={process.env.REACT_APP_RESUME_LINK}
            target="_blank"
          >
            <AiOutlineDownload />
            &nbsp;View Resume
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="Cityflo - Software Engineer"
              date="August 2022 - Present"
              content={[
                <React.Fragment>
                  Developed and maintained the two way ticketing using{" "}
                  <b className="purple">
                    <a
                      href="https://react.dev/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      ReactJS
                    </a>
                  </b>
                  &nbsp; system conjoining the customer support system team and
                  the operations team with improved customer experience and
                  internal ticket resolution.
                </React.Fragment>,
                <React.Fragment>
                  Optimized <b className="purple">30%</b> build time for
                  production code by implementing caching and utilizing relevant
                  tools.
                </React.Fragment>,
                <React.Fragment>
                  Built and maintained the CityFlo website using modern
                  technologies like{" "}
                  <b className="purple">
                    <a
                      href="https://astro.build/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Astro
                    </a>
                  </b>{" "}
                  and{" "}
                  <b className="purple">
                    <a
                      href="https://svelte.dev/"
                      rel="noreferrer"
                      target="_blank"
                    >
                      Svelte
                    </a>
                  </b>{" "}
                  resulting in <b className="purple">40%</b> reduced build and
                  response time along with utilizing DevTools like{" "}
                  <a
                    href="https://developer.chrome.com/docs/lighthouse/overview"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Lighthouse
                  </a>{" "}
                  and PageSpeed Insights for performance analysis and
                  optimization.
                </React.Fragment>,
                <React.Fragment>
                  Integrated{" "}
                  <a
                    href="https://exotel.com/products/smart-ivr/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Exotel IVR
                  </a>{" "}
                  API in <b className="purple">Django</b> backend to retrieve
                  and store IVR records, subsequently developed a customized
                  view within the internal tool to facilitate seamless access
                  and utilization of the fetched records
                </React.Fragment>,
                <React.Fragment>
                  Implemented Websocket by replacing it with Pusher with
                  enabling real-time vehicle data for the internal dashboard.
                </React.Fragment>,
              ]}
            />
            <Resumecontent
              title="Google Summer of Code (GSoC'22) - Rocket.Chat"
              date="May 2022 - Sept 2022"
              img="1"
              content={[
                <React.Fragment>
                  Implemented the feature to forward messages to channels,
                  threads, or discussions and alleviate the platform user
                  experience.
                </React.Fragment>,
                <React.Fragment>
                  Built the functionalities in ReactJS, enabling file sharing
                  across multiple rooms, supporting additional message content,
                  text formatting in the extra message field, and providing a
                  message preview.
                </React.Fragment>,
                <React.Fragment>
                  Created impact for over <b className="purple">12M+ </b>users
                  with this feature implementation catering to both business and
                  regular social communication needs on a daily basis.
                </React.Fragment>,
                <React.Fragment>
                  Collaborated with Rocket.Chat product designer and mentor to
                  determine project prototyping strategies.
                  <br />
                  <br />
                  <Button
                    style={{ width: "fit-content" }}
                    variant="primary"
                    href="https://drive.google.com/file/d/1eKA_QsoQxV2l-6HWcLAt-CGlMGrA6UNE/view?usp=sharing"
                    target="_blank"
                  >
                    <AiOutlineFolderView />
                    &nbsp;Message Forwarding - Proposal
                  </Button>
                </React.Fragment>,
              ]}
            />
            <Resumecontent
              title="CogniSaaS - Software Engineer"
              date="July 2021 - January 2022"
              content={[
                <React.Fragment>
                  Developed cross-functional services for over{" "}
                  <b className="purple">1500+</b>1500+ SaaS companies
                  facilitating customer-centric onboarding and implementation at
                  scale.
                </React.Fragment>,
                <React.Fragment>
                  Created and managed file handling with{" "}
                  <b className="purple">AWS S3</b> and JIRA Attachment
                  Integration through API impacting over 2000 projects.
                </React.Fragment>,
                <React.Fragment>
                  Refactored customer portal from scratch with code
                  optimization, and template management at the project level.
                </React.Fragment>,
                <React.Fragment>
                  Enabled tracking, prioritizing, and delivering customer use
                  cases in a single place for SaaS companies.
                </React.Fragment>,
              ]}
            />
            <Resumecontent
              title="Digital Register - Frontend Engineer"
              date="June 2021 - July 2021"
              content={[
                "Project Course - Designed and produced mobile application from scratch for career counselling: Created project based course using Flutter, AdobeXd, Firebase.",
                "Team Management - Resolved conflicting ideas: Created space for innovative ideas and their implementation, by channeling resources to respective team members on regular intervals.",
              ]}
            />
            <Resumecontent
              title="GirlScript Summer of Code"
              date="March 2021 - June 2021"
              content={[
                <React.Fragment>
                  <span style={{ fontWeight: "bold" }} className="purple">
                    Manthan
                  </span>{" "}
                  - Classroom and meeting: Refactor forum for performance and
                  improvization of Frontend code.
                </React.Fragment>,
                <React.Fragment>
                  <span style={{ fontWeight: "bold" }} className="purple">
                    Doc2Pen
                  </span>{" "}
                  - Use the flexible Editor page to type in handwritten
                  documents: Fronted Contribution on refactoring and creating
                  additional features to improve functionality.
                </React.Fragment>,
                <React.Fragment>
                  <span style={{ fontWeight: "bold" }} className="purple">
                    eminist Bible
                  </span>{" "}
                  - all inclusive space for communities: Implemented Redux for
                  state management from scratch.
                </React.Fragment>,
              ]}
            />

            <Resumecontent
              title="CAREO - Startup and Innovation"
              date="June 2020 - December 2020"
              content={[
                "Project Course - Designed and produced mobile application from scratch for career counselling: Created project based course using Flutter, AdobeXd, Firebase.",
                "Team Management - Resolved conflicting ideas: Created space for innovative ideas and their implementation, by channeling resources to respective team members on regular intervals.",
              ]}
            />
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title=" I.T [L.D. College Of Engineering, Ahmedabad] "
              date="2018 - 2022"
              content={[`CGPA: 8.36`]}
            />
            <Resumecontent
              title="12TH BOARD [New Gayatri Higher Sec. School,Ahmedabad]"
              date="2017 - 2018"
              content={["Precentage: 94%"]}
            />
            <Resumecontent
              title="10TH BOARD [New Gayatri Higher Sec. School,Ahmedabad] "
              date="2015 - 20156"
              content={["Precentage: 89%"]}
            />
            <h3 className="resume-title">Ranks and Achivements</h3>
            <Resumecontent
              title=""
              content={[
                <React.Fragment>
                  {" "}
                  Institute ranked{" "}
                  <span style={{ fontWeight: "bolder" }} className="purple">
                    #3
                  </span>{" "}
                  in DSA in GeeksForGeeks <br /> Profile Link :{" "}
                  <a
                    target="_blank"
                    href="https://auth.geeksforgeeks.org/user/nkpatel23122000/practice/"
                    rel="noreferrer"
                  >
                    GeeksForGeeks
                  </a>
                </React.Fragment>,
                <React.Fragment>
                  {" "}
                  3 star on CodeChef <br />
                  Profile Link :{" "}
                  <a
                    target="_blank"
                    href="https://www.codechef.com/users/nkp2312"
                    rel="noreferrer"
                  >
                    CodeChef
                  </a>
                </React.Fragment>,
                <React.Fragment>
                  {" "}
                  Solved 500+ questions
                  <br />
                  Profile link :{" "}
                  <a
                    target="_blank"
                    href="https://leetcode.com/nkpatel23122000/"
                    className="purple"
                    rel="noreferrer"
                  >
                    LeetCode
                  </a>
                </React.Fragment>,
              ]}
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
